import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export const scrollToTarget = function(target, offset = 150) {
  const duration = 300;

  const top = target.getBoundingClientRect().top;
  const startPos = window.pageYOffset || document.documentElement.scrollTop;
  const diff = top - offset;

  let startTime = null;
  let requestId;

  const loop = function(currentTime) {
    if (!startTime) {
      startTime = currentTime;
    }

    // Elapsed time in miliseconds
    const time = currentTime - startTime;

    const percent = Math.min(time / duration, 1);

    if (target.classList.contains('header')) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, startPos + diff * percent);
    }

    if (time < duration) {
      // Continue moving
      requestId = window.requestAnimationFrame(loop);
    } else {
      window.cancelAnimationFrame(requestId);
    }
  };
  requestId = window.requestAnimationFrame(loop);
};
